import type { OriginalAttributes } from '../core/types';

const decoder = document.createElement('textarea');
const decodeCell = (html: string): string => {
  decoder.innerHTML = html.replace(/<[^>]+>/g, ' ');
  return decoder.value.replace(/\s+/g, ' ').trim();
};

export function parseDescriptionTable(description: string | undefined): OriginalAttributes {
  if (!description) return {};
  const values: Record<string, string> = {};
  const rows = description.match(/<tr\b[^>]*>[\s\S]*?<\/tr>/gi) ?? [];
  rows.forEach((row) => {
    const cells = [...row.matchAll(/<t[dh]\b[^>]*>([\s\S]*?)<\/t[dh]>/gi)].map((match) => match[1] ?? '');
    if (cells.length < 2) return;
    const key = decodeCell(cells[0] ?? '');
    const value = decodeCell(cells[1] ?? '');
    if (key) values[key] = value;
  });
  if (Object.keys(values).length) return values;
  const documentNode = new DOMParser().parseFromString(description, 'text/html');
  documentNode.querySelectorAll('tr').forEach((row) => {
    const cells = [...row.querySelectorAll('th, td')];
    const key = decodeCell(cells[0]?.innerHTML ?? '');
    if (key && cells[1]) values[key] = decodeCell(cells[1].innerHTML);
  });
  return values;
}
